module.exports = __webpack_public_path__ + "media/images/icons/twotone/tag-f835aa14a2036f3ead9e0e448b940f76.svg";